import { ArrowDown, CalendarDays, Mail } from 'lucide-react';
import { CONNECT_OPTIONS } from '@/data/contact';
import { Reveal } from '../Reveal';
import { scrollToId } from '@/lib/scroll';

const ICONS = { mail: Mail, calendar: CalendarDays };

export const ConnectOptions = () => (
  <section aria-labelledby="connect-heading" data-testid="connect-options" className="bg-mist py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 id="connect-heading" className="sr-only">
        Choose how to connect
      </h2>
      <div className="grid gap-6 md:grid-cols-2">
        {CONNECT_OPTIONS.map((opt, i) => {
          const Icon = ICONS[opt.icon];
          return (
            <Reveal key={opt.id} delay={i * 0.08} className="h-full">
              <div
                data-testid={`connect-${opt.id}`}
                className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-8 sm:p-10"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-navy-900">
                  <Icon className="h-5 w-5 text-gold-500" aria-hidden="true" />
                </span>
                <h3 className="mt-6 text-xl font-extrabold tracking-tight text-navy-900 sm:text-2xl">
                  {opt.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-slate-600">{opt.copy}</p>
                <div className="mt-auto pt-8">
                  <button
                    type="button"
                    onClick={() => scrollToId(opt.target)}
                    data-testid={`connect-${opt.id}-btn`}
                    className="group inline-flex items-center gap-2 rounded-md bg-navy-900 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-navy-700"
                  >
                    {opt.actionLabel}
                    <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
